export default __webpack_public_path__ + "static/media/alert_search.2e2dbf27.png";